import { render, staticRenderFns } from "./BorrowingSchedule.vue?vue&type=template&id=260c427d"
import script from "./BorrowingSchedule.vue?vue&type=script&lang=js"
export * from "./BorrowingSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports